import { Navigate, useLocation } from 'react-router-dom';
import { Spinner, Container } from 'react-bootstrap';
import { useAuthStore } from '@store/auth.store';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredAuthorities?: string[];
}

/* eslint-disable react/prop-types */

/**
 * Protected route wrapper that checks authentication and authorities
 * Matches Angular's UserRouteAccessService behavior
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredAuthorities = [] }) => {
    const { isAuthenticated, isIdentityResolved, isLoading, hasAnyAuthority } = useAuthStore();
    const location = useLocation();

    // Show loading while checking identity
    if (!isIdentityResolved || isLoading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" variant="primary" />
            </Container>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check authorities if specified
    if (requiredAuthorities.length > 0 && !hasAnyAuthority(requiredAuthorities)) {
        return <Navigate to="/403" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute; 